/* eslint-disable */
import {Service} from 'components/Shared/server';
import {EnergyContentResult} from 'models/EnergyContentResult';


export const routeGetGetEnergySvgContent = (productId: string, multiple?: boolean) => `/api/energy/energysvgcontent?productId=${encodeURIComponent(productId)}&multiple=${multiple}`;
export function getGetEnergySvgContent(productId: string, multiple?: boolean): Promise<EnergyContentResult> {
  return Service.get<EnergyContentResult>({
    url: routeGetGetEnergySvgContent(productId, multiple)
  });
}
